import * as S from "./GlobalToWalletsSection.styles";

export const GlobalToWalletsSection = () => {
  return (
    <S.Wrapper
      id="why-brazil"
      style={{
        zIndex: "2",
      }}
    >
      <S.Title>From Global Business to Brazilian Wallets In Seconds</S.Title>

      <S.Text>
        Whether you're scaling a digital platform or launching in Brazil for the
        first time, PayQuest makes every step seamless — from integration to
        instant payins.
      </S.Text>

      <S.CardSolo>
        <S.TextCardSolo>
          <S.SpanCardSolo></S.SpanCardSolo>
          Real-time PIX payins
        </S.TextCardSolo>

        <S.TextCardSolo>
          <S.SpanCardSolo></S.SpanCardSolo>
          Localized KYC and verification
        </S.TextCardSolo>

        <S.TextCardSolo>
          <S.SpanCardSolo></S.SpanCardSolo>
          Fully compliant with BCB (Res. 277)
        </S.TextCardSolo>

        <S.TextCardSolo>
          <S.SpanCardSolo></S.SpanCardSolo>
          Seamless API for integrations
        </S.TextCardSolo>
      </S.CardSolo>

      <div
        style={{
          maxWidth: "919px",
          margin: "128px auto 0",
        }}
      >
        <iframe
          style={{
            width: "100%",
            height: "525px",
            borderRadius: "16px",
            display: "block",
          }}
          width="560"
          height="315"
          src="https://www.youtube.com/embed/5IT77iQGtl0?si=TUG0xnHqkZHkF7UF&amp;controls=0"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
    </S.Wrapper>
  );
};
